/**
 * Checklist step rules (SPEC.md §5.4, decision D12).
 *
 * A step that expects photo proof never blocks completion. A technician in a plant
 * room with a dead camera, a full phone or no storage permission must still be able
 * to finish the SOP — the same reasoning as D2 for ticket resolution, and Rule 4 for
 * offline writes. Missing proof is recorded and reported, never refused.
 */
/**
 * True when a step was completed but the photo it expected is absent.
 *
 * Derived rather than stored: a persisted flag would drift the moment a photo
 * arrived late from the offline outbox.
 */
export function isStepMissingProof(step) {
    return step.isCompleted && step.requirePhoto && step.photoAttachmentId === null;
}
/** A step still outstanding — required, and not yet done. */
export function isStepOutstanding(step) {
    return step.isRequired && !step.isCompleted;
}
export function summariseChecklist(steps) {
    return {
        total: steps.length,
        completed: steps.filter((step) => step.isCompleted).length,
        outstandingRequired: steps.filter(isStepOutstanding).length,
        missingProof: steps.filter(isStepMissingProof).length,
    };
}
//# sourceMappingURL=checklist.js.map